import { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Country } from "@/domains/auth/constants/country";
import { countriesSelector, setResetPasswordMethod } from "@/domains/auth/slice";
import useResetPasswordSmsCode from "@/domains/auth/hooks/reset-password/useResetPasswordSmsCode";
import AuthResetPasswordCheckSMSCodeContainer from "@/domains/auth/containers/reset-password/method/AuthResetPasswordCheckSMSCodeContainer";
import AuthTitle from "@/domains/auth/components/AuthTitle";
import AuthResetPasswordSMS from "@/domains/auth/components/reset-password/method/AuthResetPasswordSMS";

export default function AuthResetPasswordSmsContainer() {
  const { t } = useTranslation("auth");
  const dispatch = useAppDispatch();
  const countries = useAppSelector(countriesSelector);
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [country, setCountry] = useState<Country>(Country.Russia);
  const { sendCodeHandler, sendIsCompleted, sendError, setSendIsCompleted } =
    useResetPasswordSmsCode();

  const currCountry = useMemo(() => {
    const findedCountry = countries.find((item) => item.country === country);
    return findedCountry;
  }, [countries, country]);

  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      sendCodeHandler(`${currCountry.code}${phoneNumber}`);
    },
    [sendCodeHandler, phoneNumber, currCountry],
  );

  const backToChooseMethod = useCallback(() => {
    dispatch(setResetPasswordMethod(null));
  }, [dispatch]);

  const backToInputPhone = useCallback(() => {
    setPhoneNumber("");
    setSendIsCompleted(null);
  }, []);

  const onChangeCountry = useCallback((value: Country) => {
    setCountry(value);
  }, []);

  const onPhoneNumberChageHandler = useCallback((phone: string) => {
    let value = phone;
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    setPhoneNumber(value);
  }, []);

  if (sendIsCompleted) {
    return (
      <>
        <AuthTitle back={backToInputPhone}>{t("auth.enterVerificationCode")}</AuthTitle>{" "}
        <AuthResetPasswordCheckSMSCodeContainer address={`${currCountry.code}${phoneNumber}`} />
      </>
    );
  }

  return (
    <>
      <AuthTitle back={backToChooseMethod}>Сброс пароля</AuthTitle>
      <AuthResetPasswordSMS
        error={sendError}
        phoneNumber={phoneNumber}
        onPhoneNumberChange={onPhoneNumberChageHandler}
        onSubmit={onSubmit}
        countries={countries}
        country={currCountry}
        onChangeCountry={onChangeCountry}
      />
    </>
  );
}
